import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, MenuItem } from 'react-bootstrap';
import styled from 'styled-components';
import { globalStateSelector } from 'store/selector';
import { Tip } from 'modules/common/components';
import { connect } from 'react-redux';
import { localStore } from '../../../../../helpers';
import { NameCard, DropdownToggle, Icon, ModalTrigger } from 'modules/theme';
import { UserHelper } from '../styles';
import { companyMobileMenuIcon } from '../../../../../helpers/dotenv';
import CommonManager from '../../../../../helpers/common';
// import {
//   ChangePassword,
//   NotificationSettings
// } from 'modules/settings/profile/containers';

const commonManger = new CommonManager();

const srcMenuIcon = commonManger.isValidUrl(companyMobileMenuIcon) ? companyMobileMenuIcon : `/images/${companyMobileMenuIcon}`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
  border-left: 1px solid #d6d6d6;
  span {
    float: none;
    margin: 0 10px;
  }
  span.custom-icon {
    margin: 0 0px;
  }
`;

const NameCardWrapper = styled.div``;

const NavItem = styled.div`
  .badge.badge-badge-custom {
    margin-right: 10px;
    display: inline-block;
    min-width: 10px;
    padding: 10px 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    background: #2b3c93;
    border-radius: 10px;
  }
  .dropdown {
    height: 100%;
  }
  .dropdown > div {
    height: 100%;
  }
  .dropdown > div > div {
    height: 100%;
  }
  .dropdown > div > div > div {
    height: 100%;
  }
`;

export class QuickNavigation extends Component {
  render() {
    let { logout, currentUser } = this.props;
    const { __ } = this.context;
    currentUser = currentUser || {};
    const user = {
      ...currentUser,
      name:
        currentUser.name && currentUser.name.length > 30
          ? currentUser.name.substring(0, 30) + '...'
          : currentUser.name,
      profilePic:
        currentUser.imagePath && currentUser.profilePic
          ? `${currentUser.imagePath + currentUser.profilePic}`
          : null,
    };
    const tenantName = localStore.getItem('selected-tenant') || '';
    return (
      <div className='responsive-header-wrapper h-100'>
        <img src={srcMenuIcon} />
        <nav className='h-100'>
          <NavItem className='header-navigation h-100'>
            <Dropdown id='dropdown-user' pullRight>
              <DropdownToggle bsRole='toggle'>
                <UserHelper>
                  {tenantName && (
                    <Tip text={tenantName} placement='bottom'>
                      <span
                        className='badge badge-custom'
                        style={{
                          maxWidth: '100px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {tenantName}
                      </span>
                    </Tip>
                  )}
                  <UserInfo>
                    {`${currentUser.name}`}
                    <NameCard.Avatar
                      showTeamColorPattern={-1}
                      user={user}
                      size={30}
                    />
                    <span className='material-symbols-outlined custom-icon'>
                      expand_more
                    </span>
                  </UserInfo>
                </UserHelper>
              </DropdownToggle>
              <Dropdown.Menu>
                <NameCardWrapper>
                  <NameCard
                    user={{
                      ...currentUser,
                      profilePic:
                        currentUser.imagePath && currentUser.profilePic
                          ? `${currentUser.imagePath + currentUser.profilePic}`
                          : null,
                    }}
                  />
                </NameCardWrapper>
                {/* <MenuItem divider /> */}

                {/* <li>
                  <Link to={`/settings/team/details/${currentUser._id}`}>
                    {__('View Profile')}
                  </Link>
                </li> */}

                {/* <li>
                  <Link to={`/justTrying`}>{__('Add Customers')}</Link>
                </li> */}

                {/* <ModalTrigger
                  title="Change Password"
                  trigger={
                    <li>
                      <a>{__('Change Password')}</a>
                    </li>
                  }
                >
                  <ChangePassword />
                </ModalTrigger> */}
                <MenuItem divider />
                <MenuItem onClick={logout}>{__('Sign out')}</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </NavItem>
        </nav>
      </div>
    );
  }
}
QuickNavigation.propTypes = {
  logout: PropTypes.func,
};

QuickNavigation.contextTypes = {
  currentUser: PropTypes.object,
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
});

const dispatchToProps = (dispatch) => ({
  dynamicUpdate: (data) => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  },
});
export default connect(stateToProps, dispatchToProps)(QuickNavigation);



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/QuickNavigation.js